import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 400px;
`;

export const ContentContainer = styled.div`
  padding: 16px;

  .gm-ant-select {
    width: 100%;
  }

  .gm-ant-checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 200px;
    overflow-y: auto;
    width: 100%;
    padding-left: 8px;
    padding-top: 8px;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #00000040;

  button {
    height: 28px;
  }
`;

export const Label = styled.div`
  color: #00000040;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;

export const DimensionOptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;

  > div:first-of-type {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
